import is from '@sindresorhus/is';
import { useEffect } from 'react';
import type { UseFormReturn } from 'react-hook-form';

import type { SkillShort } from '~/shared/data-contract/skill';

import type { LearningOpportunityFormState } from '../form-state';

export const useAutoAddDetectedSkills = ({
    blacklistedSkillIds,
    detectedSkills,
    methods,
    mode,
    skillLimit,
}: {
    readonly blacklistedSkillIds: readonly string[];
    readonly detectedSkills: readonly SkillShort[];
    readonly methods: UseFormReturn<LearningOpportunityFormState>;
    readonly mode: 'create' | 'edit' | 'view';
    readonly skillLimit: number;
}): void => {
    useEffect(() => {
        if (mode !== 'create' || is.emptyArray(detectedSkills)) return;

        const selectedSkills = methods.getValues('skills') ?? [];
        const selectedSkillIds = selectedSkills.map((skill) => skill.id);
        const newDetectedSkills = detectedSkills.filter(
            (skill) => !selectedSkillIds.includes(skill.id) && !blacklistedSkillIds.includes(skill.id),
        );
        const remainingSkillSlots = Math.max(0, skillLimit - selectedSkills.length);
        const skillsToAdd = newDetectedSkills.slice(0, remainingSkillSlots);

        if (skillsToAdd.length === 0) return;

        methods.setValue('skills', [...selectedSkills, ...skillsToAdd], {
            shouldDirty: true,
            shouldValidate: true,
        });
    }, [blacklistedSkillIds, detectedSkills, methods, mode, skillLimit]);
};
